<div class="flex items-center justify-between" [class.pagination-lg]="large">
  <!-- Items info -->
  <div class="pagination-info text-sm text-text-muted">
    <span class="font-medium text-text-primary">{{ startItem }}</span> bis <span class="font-medium text-text-primary">{{ endItem }}</span> von
    <span class="font-medium text-text-primary">{{ totalItems }}</span> Ergebnissen
  </div>

  <!-- Pagination controls -->
  <div class="flex items-center gap-1">
    <!-- Previous button -->
    @if (showArrows) {
      <button
        type="button"
        class="pagination-btn"
        [disabled]="currentPage === 1"
        [class.opacity-50]="currentPage === 1"
        [class.cursor-not-allowed]="currentPage === 1"
        (click)="previousPage()"
      >
        <span class="material-icons text-lg">chevron_left</span>
      </button>
    }

    <!-- Page numbers -->
    @if (visiblePages[0] > 1) {
      <button type="button" class="pagination-btn" (click)="goToPage(1)">1</button>
      @if (visiblePages[0] > 2) {
        <span class="px-2 text-text-muted">...</span>
      }
    }

    @for (page of visiblePages; track page) {
      <button type="button" class="pagination-btn" [class.active]="page === currentPage" (click)="goToPage(page)">
        {{ page }}
      </button>
    }

    @if (visiblePages[visiblePages.length - 1] < totalPages) {
      @if (visiblePages[visiblePages.length - 1] < totalPages - 1) {
        <span class="px-2 text-text-muted">...</span>
      }
      <button type="button" class="pagination-btn" (click)="goToPage(totalPages)">{{ totalPages }}</button>
    }

    <!-- Next button -->
    @if (showArrows) {
      <button
        type="button"
        class="pagination-btn"
        [disabled]="currentPage === totalPages"
        [class.opacity-50]="currentPage === totalPages"
        [class.cursor-not-allowed]="currentPage === totalPages"
        (click)="nextPage()"
      >
        <span class="material-icons text-lg">chevron_right</span>
      </button>
    }
  </div>
</div>
